import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { TextInput, Button, Paper, Title, Text, Container, Stack } from '@mantine/core';
import { useForm } from '@mantine/form';
import { authService } from '../services/api';
import { RegisterData } from '../types/auth';

export default function Register() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  const form = useForm({
    initialValues: {
      email: '',
      name: '',
    },
    validate: {
      email: (value) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
      name: (value) => (value.length < 2 ? 'Name must be at least 2 characters' : null),
    },
  });

  const handleSubmit = async (values: RegisterData) => {
    try {
      setError('');
      const user = await authService.register(values);
      // Store user data in localStorage or state management
      localStorage.setItem('user', JSON.stringify(user));
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.message || 'Registration failed. Please try again.');
    }
  };

  return (
    <Container size={420} my={40}>
      <Title ta="center">Create Account</Title>
      <Text c="dimmed" size="sm" ta="center" mt={5}>
        Join Bet Buddy to start tracking your bets
      </Text>

      <Paper withBorder shadow="md" p={30} mt={30} radius="md">
        <form onSubmit={form.onSubmit(handleSubmit)}>
          <Stack>
            <TextInput
              label="Email"
              placeholder="your@email.com"
              required
              {...form.getInputProps('email')}
            />

            <TextInput
              label="Name"
              placeholder="Your name"
              required
              {...form.getInputProps('name')}
            />

            {error && (
              <Text c="red" size="sm">
                {error}
              </Text>
            )}

            <Button type="submit" fullWidth mt="xl">
              Register
            </Button>

            <Text ta="center" size="sm">
              Already have an account?{' '}
              <Link to="/" style={{ textDecoration: 'none' }}>
                Sign in
              </Link>
            </Text>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
}